import { combineReducers } from "redux";
import registration from "./registration";

const rootReducers = combineReducers({
  registration
});

export default rootReducers;
